import { pick, FlowHttpRequestOptions, mixHeadersOptions } from '@snfe/flow-yapi-helpers';
import * as model from '@/model';
import http from '../http';

/**
 * @desc id=1513549, catid=257503, projectId=41427, created=2025-03-07 16:59:46, last-modified=2025-04-03 15:10:39
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/webApi/ccp/game/rank/top)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1513549)
 */
export function postCcpGameRankTop(params: model.ccp.IPostCcpGameRankTopParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.ccp.IPostCcpGameRankTopResponse>('/webApi/ccp/game/rank/top', {
    data: pick(params, ['id']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1513449, catid=257503, projectId=41427, created=2025-03-07 14:23:09, last-modified=2025-05-19 16:04:35
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/webApi/ccp/game/list)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1513449)
 */
export function postCcpGameList(params: model.ccp.IPostCcpGameListParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.ccp.IPostCcpGameListResponse>('/webApi/ccp/game/list', {
    data: params,
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1513543, catid=257503, projectId=41427, created=2025-03-07 16:50:39, last-modified=2025-04-02 16:34:44
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/webApi/ccp/game/updateDeclaration)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1513543)
 */
export function postCcpGameUpdateDeclaration(params: model.ccp.IPostCcpGameUpdateDeclarationParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.ccp.IPostCcpGameUpdateDeclarationResponse>('/webApi/ccp/game/updateDeclaration', {
    data: pick(params, ['id', 'declaration']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1513528, catid=257503, projectId=41427, created=2025-03-07 16:17:09, last-modified=2025-03-17 14:57:27
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/webApi/ccp/game/registration)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1513528)
 */
export function postCcpGameRegistration(params: model.ccp.IPostCcpGameRegistrationParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.ccp.IPostCcpGameRegistrationResponse>('/webApi/ccp/game/registration', {
    data: pick(params, ['id', 'declaration']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1513556, catid=257503, projectId=41427, created=2025-03-07 17:28:10, last-modified=2025-03-31 11:02:27
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/webApi/ccp/game/rank/all)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1513556)
 */
export function postCcpGameRankAll(params: model.ccp.IPostCcpGameRankAllParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.ccp.IPostCcpGameRankAllResponse>('/webApi/ccp/game/rank/all', {
    data: pick(params, ['id']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1513715, catid=257503, projectId=41427, created=2025-03-10 10:40:25, last-modified=2025-03-24 14:32:12
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/webApi/ccp/game/info)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1513715)
 */
export function postCcpGameInfo(params: model.ccp.IPostCcpGameInfoParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.ccp.IPostCcpGameInfoResponse>('/webApi/ccp/game/info', {
    data: pick(params, ['id']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1513536, catid=257503, projectId=41427, created=2025-03-07 16:31:11, last-modified=2025-05-22 10:53:04
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/webApi/ccp/game/detail)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1513536)
 */
export function postCcpGameDetail(params: model.ccp.IPostCcpGameDetailParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.ccp.IPostCcpGameDetailResponse>('/webApi/ccp/game/detail', {
    data: pick(params, ['id']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1513580, catid=257503, projectId=41427, created=2025-03-07 18:20:06, last-modified=2025-03-07 18:25:46
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/webApi/ccp/game/question/list)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1513580)
 */
export function postCcpGameQuestionList(params: model.ccp.IPostCcpGameQuestionListParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.ccp.IPostCcpGameQuestionListResponse>('/webApi/ccp/game/question/list', {
    data: pick(params, ['id']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1514090, catid=257503, projectId=41427, created=2025-03-11 17:22:53, last-modified=2025-03-11 17:28:05
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/webApi/ccp/game/done)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1514090)
 */
export function postCcpGameDone(params: model.ccp.IPostCcpGameDoneParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.ccp.IPostCcpGameDoneResponse>('/webApi/ccp/game/done', {
    data: pick(params, ['id']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1513832, catid=257544, projectId=41427, created=2025-03-10 17:15:14, last-modified=2025-03-12 15:10:18
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/webApi/ccp/problem/submission/list)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1513832)
 */
export function postCcpProblemSubmissionList(params: model.ccp.IPostCcpProblemSubmissionListParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.ccp.IPostCcpProblemSubmissionListResponse>('/webApi/ccp/problem/submission/list', {
    data: pick(params, ['id']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1516408, catid=257544, projectId=41427, created=2025-03-24 14:16:35, last-modified=2025-03-24 14:20:27
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/webApi/ccp/problem/model/score)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1516408)
 */
export function postCcpProblemModelScore(params: model.ccp.IPostCcpProblemModelScoreParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.ccp.IPostCcpProblemModelScoreResponse>('/webApi/ccp/problem/model/score', {
    data: pick(params, ['id', 'score']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc 前端看是否有加防抖的必要，后段有限流1分钟最多60次保存
 * @desc id=1514397, catid=257544, projectId=41427, created=2025-03-13 11:22:51, last-modified=2025-04-03 14:53:19
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/webApi/ccp/problem/codeSave)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1514397)
 */
export function postCcpProblemCodeSave(params: model.ccp.IPostCcpProblemCodeSaveParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.ccp.IPostCcpProblemCodeSaveResponse>('/webApi/ccp/problem/codeSave', {
    data: pick(params, ['id', 'code', 'language']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1513794, catid=257544, projectId=41427, created=2025-03-10 16:03:06, last-modified=2025-03-25 10:59:39
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/webApi/ccp/problem/answerInformation)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1513794)
 */
export function postCcpProblemAnswerInformation(
  params: model.ccp.IPostCcpProblemAnswerInformationParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.ccp.IPostCcpProblemAnswerInformationResponse>('/webApi/ccp/problem/answerInformation', {
    data: pick(params, ['id']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1514067, catid=257544, projectId=41427, created=2025-03-11 16:53:50, last-modified=2025-03-24 14:16:05
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/webApi/ccp/problem/submission/run)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1514067)
 */
export function postCcpProblemSubmissionRun(params: model.ccp.IPostCcpProblemSubmissionRunParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.ccp.IPostCcpProblemSubmissionRunResponse>('/webApi/ccp/problem/submission/run', {
    data: pick(params, ['id', 'code', 'language']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1514062, catid=257544, projectId=41427, created=2025-03-11 16:49:54, last-modified=2025-03-13 11:29:07
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/webApi/ccp/problem/codeUpload)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1514062)
 */
export function postCcpProblemCodeUpload(params: model.ccp.IPostCcpProblemCodeUploadParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.ccp.IPostCcpProblemCodeUploadResponse>('/webApi/ccp/problem/codeUpload', {
    data: pick(params, ['id', 'code', 'language']),
    ...mixHeadersOptions(options, { 'Content-Type': 'multipart/form-data' }),
  });
}

/**
 * @desc id=1513815, catid=257544, projectId=41427, created=2025-03-10 16:56:48, last-modified=2025-03-12 15:10:03
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/webApi/ccp/problem/submission/latest)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1513815)
 */
export function postCcpProblemSubmissionLatest(
  params: model.ccp.IPostCcpProblemSubmissionLatestParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.ccp.IPostCcpProblemSubmissionLatestResponse>('/webApi/ccp/problem/submission/latest', {
    data: pick(params, ['id']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1513853, catid=257544, projectId=41427, created=2025-03-10 19:25:58, last-modified=2025-05-21 17:05:22
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/webApi/ccp/problem/chat/action)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1513853)
 */
export function postCcpProblemChatAction(params: model.ccp.IPostCcpProblemChatActionParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.ccp.IPostCcpProblemChatActionResponse>('/webApi/ccp/problem/chat/action', {
    data: pick(params, ['answerId', 'chatSessionId', 'userInput', 'retryGenerateFlag']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1513847, catid=257544, projectId=41427, created=2025-03-10 19:09:34, last-modified=2025-04-16 17:03:28
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/webApi/ccp/problem/chat/historyList)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1513847)
 */
export function postCcpProblemChatHistoryList(params: model.ccp.IPostCcpProblemChatHistoryListParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.ccp.IPostCcpProblemChatHistoryListResponse>('/webApi/ccp/problem/chat/historyList', {
    data: pick(params, ['id']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1513839, catid=257544, projectId=41427, created=2025-03-10 18:57:19, last-modified=2025-05-21 17:02:12
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/webApi/ccp/problem/chat/detail)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1513839)
 */
export function postCcpProblemChatDetail(params: model.ccp.IPostCcpProblemChatDetailParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.ccp.IPostCcpProblemChatDetailResponse>('/webApi/ccp/problem/chat/detail', {
    data: pick(params, ['chatSessionId', 'answerId']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1514052, catid=257544, projectId=41427, created=2025-03-11 16:18:21, last-modified=2025-03-19 15:58:51
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/webApi/ccp/problem/run)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1514052)
 */
export function postCcpProblemRun(params: model.ccp.IPostCcpProblemRunParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.ccp.IPostCcpProblemRunResponse>('/webApi/ccp/problem/run', {
    data: pick(params, ['id', 'code', 'language', 'example']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}
